<template>
    <div class="item-type scale-wrapper">
        <image-editor v-if="dataStore.activeType == 'image'"></image-editor>
        <video-editor v-if="dataStore.activeType == 'video'"></video-editor>
        <three-dee-editor v-if="dataStore.activeType == '3D'"></three-dee-editor>
        <text-editor></text-editor>
        <scale-options />

        <div class="form-group scale-save" v-if="editable">
            <button class="btn btn-primary" v-on:click.prevent="addScale($event)">{{ language.add_type_save }}</button>
            <a class="cancel" href="#" v-on:click.prevent="globalFunctions.toggleAddMedia">{{ language.add_type_cancel }}</a>
        </div>
    </div>
</template>

<script>

import dataStore from "../../store";
import globalFunctions from "../../globalFunctions";
import VideoEditor from './../item-type/VideoEditor';
import ImageEditor from './../item-type/ImageEditor';
import ThreeDeeEditor from './../item-type/ThreeDeeEditor';
import TextEditor from '../item-type/TextEditor';
import ScaleOptions from './../Project/ScaleOptions'

export default {

    components: {
        ImageEditor,
        VideoEditor,
        ThreeDeeEditor,
        TextEditor,
        ScaleOptions
    },

    data() {
        return {
            dataStore,
            globalFunctions,
        }
    },

    computed: {
        editable: function() {
            return this.superadmin ? true : ( this.dataStore.project.allowToEdit && this.dataStore.isLoaded )
        }
    },

    inject: [ 'language', 'superadmin' ],

    methods: {

        addScale: function(event) {

            let old = this.dataStore.projectItems[this.dataStore.activeIndex];

            let allowText = this.validateTextEditor();
            if(!allowText) return;

            if(this.dataStore.activeType === '3D') {
                let allow = this.validateIframe();
                if(!allow) return;
            }

            event.target.disabled = true;

            let otherObject = {
                activeType : this.dataStore.activeType,
                activeScaleType : this.dataStore.activeScaleType,
                questionType : this.dataStore.questionType,
                question : { description : this.dataStore.activeQuestion },
                scaleOptions : this.dataStore.project.scaleOptions.length ? this.dataStore.project.scaleOptions : [],
                allowMulti : this.dataStore.allowMultiAnswersScale,
            };
            
            if( this.dataStore.allowMultiAnswersScale ) {
                otherObject.amountAnswers = this.dataStore.amountAnswers
                otherObject.allowLimitMarkers = this.dataStore.allowLimitMarkers
            } else {
                otherObject.amountAnswers = 0
                otherObject.allowLimitMarkers = false
            }

            if(old && old.hasOwnProperty("id")) {
                otherObject.id = old.id;
            }

            if(this.dataStore.activeType === '3D') {
                otherObject.active3dIframe = this.dataStore.active3dIframe
            }

            if(this.dataStore.activeType === 'video') {
                otherObject.videourl = this.dataStore.activeVideoUrl
                otherObject.question.youtube_video = this.dataStore.typeOfVideo
            }

            if(this.dataStore.editMode) {

                if(this.dataStore.activeType === 'image') {
                    if(typeof(this.dataStore.popUpMediaFile) === 'string' && this.dataStore.popUpMediaFile.includes('data:image/') ){
                        otherObject.file = this.dataStore.popUpMediaFile;
                    } else {
                        if(old.hasOwnProperty('file')){
                            otherObject.file = old.file;
                        } else {
                            otherObject.assets = old.assets;
                        }
                    }

                    otherObject.name = this.dataStore.activeFileName;
                }

                this.globalFunctions.toggleAddMedia(this.dataStore.activeType, true);
                otherObject.updated = true;
                this.dataStore.projectItems.splice( this.dataStore.activeIndex, 1, otherObject );

            } else {

                if(this.dataStore.activeType === 'image') {
                    otherObject.file = this.dataStore.popUpMediaFile;
                    otherObject.name = this.dataStore.activeFileName;
                }

                this.dataStore.projectItems.push(otherObject)
                this.globalFunctions.toggleAddMedia();
            }

            event.target.disabled = false;

        },

        validateIframe: function() {

            if(this.dataStore.active3dIframe.includes('</iframe>')) {
                this.dataStore.errorsAdmin = this.dataStore.errorsAdmin.filter(err => err.name !== '3d')
                return true;
            }

            else {
                this.dataStore.errorsAdmin.push({
                    name : '3d',
                    error : "Inte giltig iframe",
                })

                return false;
            }

        },

        validateTextEditor: function() {

            if( this.dataStore.activeQuestion.length ) {
                this.dataStore.errorsAdmin = this.dataStore.errorsAdmin.filter(err => err.name !== 'text')
                return true;
            }

            else {

                this.dataStore.errorsAdmin.push({
                    name : 'text',
                    error : this.language.error_multi_choice
                })

                return false;
            }

        }

    }

};
</script>
